import { render, staticRenderFns } from "./BubbleChartPlotly.vue?vue&type=template&id=5b65b2a6&scoped=true&"
import script from "./BubbleChartPlotly.vue?vue&type=script&lang=js&"
export * from "./BubbleChartPlotly.vue?vue&type=script&lang=js&"
import style0 from "./BubbleChartPlotly.vue?vue&type=style&index=0&id=5b65b2a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b65b2a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b65b2a6')) {
      api.createRecord('5b65b2a6', component.options)
    } else {
      api.reload('5b65b2a6', component.options)
    }
    module.hot.accept("./BubbleChartPlotly.vue?vue&type=template&id=5b65b2a6&scoped=true&", function () {
      api.rerender('5b65b2a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/stats/charts/BubbleChartPlotly.vue"
export default component.exports